import { render, staticRenderFns } from "./InvoicesConsolidationsTableMobile.vue?vue&type=template&id=63f0324b&scoped=true"
import script from "./InvoicesConsolidationsTableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesConsolidationsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoicesConsolidationsTableMobile.vue?vue&type=style&index=0&id=63f0324b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f0324b",
  null
  
)

export default component.exports